import * as THREE from 'three';
import { createPointMaterial } from '../common/PointMaterial';
export default class PointRenderer {

    constructor(scene, pointSystem, options = {}) {

        this.scene = scene;
        this.pointSystem = pointSystem;

        this.options = {

            color: 0x38bdf8,
            size: 0.055,
            opacity: 0.95,

            ...options

        };

        this.geometry = new THREE.BufferGeometry();

        this.geometry.setAttribute(

            'position',

            new THREE.BufferAttribute(

                this.pointSystem.getPositions(),

                3

            )

        );

		this.geometry.setAttribute(
		
		    'scale',
		
		    new THREE.BufferAttribute(
		
		        this.pointSystem.getScales(),
		
		        1
		
		    )
		
		);
		
       this.material = createPointMaterial({
        
            color: this.options.color,
            opacity: this.options.opacity,
            size: this.options.size
        
        });

        this.points = new THREE.Points(

            this.geometry,

            this.material

        );

        this.scene.add(this.points);

    }

   update() {
    
        this.geometry.attributes.position.needsUpdate = true;
    
        this.geometry.attributes.scale.needsUpdate = true;
    
    }

   setColor(color) {
    
        this.material.uniforms.uColor.value.set(color);
    
    }

    setOpacity(opacity) {

       this.material.uniforms.uOpacity.value = opacity;

    }

    setSize(size) {

       this.material.uniforms.uSize.value = size;

    }

    dispose() {

        this.scene.remove(this.points);

        this.geometry.dispose();

        this.material.dispose();

    }

}
